import styled from 'styled-components';

interface ContainerProps {
  themeLess: boolean;
}

export const Container = styled.div<ContainerProps>`
  border-radius: 10px;
  background-color: ${(props) =>
    props.themeLess ? 'transparent' : props.theme.colors.card};
  padding: ${(props) => (props.themeLess ? 0 : 15)}px;
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 10px;
  align-self: flex-start;
`;

export const Title = styled.p`
  font-size: 12px;
  color: ${(props) => props.theme.colors.text};
  font-weight: 600;
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ToggleButton = styled.div`
  cursor: pointer;
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  transition: all 0.2 ease-in-out;

  &:hover {
    background-color: ${(props) => props.theme.colors.primaryLight};
  }
`;
